"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const checkInputStyles_1 = __importDefault(require("./checkInputStyles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const utils_1 = require("../../utils/utils");
const icon_1 = __importStar(require("../icon/icon"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const text_1 = __importStar(require("../text/text"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
const CheckInput = ({ choices, label, error = '', setSelected, selected = [] }) => {
    let choicesUpdated = choices.map((choice) => {
        const newChoice = { ...choice };
        let choiceSelected;
        if (selected) {
            choiceSelected = selected.find((el) => choice.value.toString() === el.toString());
        }
        if (choiceSelected !== undefined)
            newChoice.checked = true;
        else
            newChoice.checked = false;
        return newChoice;
    });
    const [choicesState, setChoicesState] = (0, react_1.useState)(choicesUpdated);
    (0, react_1.useEffect)(() => {
        choicesUpdated = choices.map((choice) => {
            const newChoice = { ...choice };
            let choiceSelected;
            if (selected) {
                choiceSelected = selected.find((el) => choice.value.toString() === el.toString());
            }
            if (choiceSelected !== undefined) {
                newChoice.checked = true;
            }
            else {
                newChoice.checked = false;
            }
            return newChoice;
        });
        setChoicesState(choicesUpdated);
    }, [selected]);
    const handleChange = (choice) => {
        const newSelected = selected ? [...selected] : [];
        const newChoiceState = [...choicesState];
        const temp = newChoiceState.map((el) => {
            if (el === choice) {
                const newChoice = { ...el };
                const isChecked = el.checked;
                // update value
                newChoice.checked = !isChecked;
                // add to selected group
                if (newChoice.checked) {
                    newSelected.push(choice.value.toString());
                } // remove from selected group
                else {
                    (0, utils_1.removeElement)(choice.value, newSelected);
                }
                return newChoice;
            }
            return el;
        });
        setChoicesState(temp);
        setSelected([]);
        setSelected(newSelected);
    };
    const showError = !!error;
    const errorLabel = `${label} is invalid.`;
    const checkBox = (choice) => {
        if (react_native_1.Platform.OS === 'web')
            return (react_1.default.createElement(icon_1.default, { name: choice.checked ? icon_1.CHECKED_BOX_ICON : icon_1.UNCHECKED_BOX_ICON, fill: choice.checked ? theme_1.default.colors.COLOR_GRAY_DARK : theme_1.default.colors.COLOR_GRAY_LIGHTER }));
        return (react_1.default.createElement(react_native_paper_1.Checkbox, { key: choice.value, status: choice.checked ? 'checked' : 'unchecked', onPress: () => handleChange(choice) }));
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
        label && (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK, style: textStyles_1.default.bold }, label)),
        choicesState.map((choice) => (react_1.default.createElement(pressableElement_1.default, { onPress: () => handleChange(choice), key: choice.value, eventName: "choose_option_check_input", style: [styles_1.default.flexDirectionRow, react_native_1.Platform.OS === 'web' ? { marginVertical: 5 } : {}] },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.flexDirectionColumn,
                    styles_1.default.centerChildHorizontalVertical,
                    react_native_1.Platform.OS === 'web' ? { marginRight: 5 } : {},
                ] }, checkBox(choice)),
            typeof choice.label === 'string' ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionColumn, styles_1.default.centerChildHorizontalVertical] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, choice.label))) : (choice.label)))),
        showError && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: checkInputStyles_1.default.info },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_ERROR, color: colors_1.default.COLOR_CRITICAL }, errorLabel))))));
};
CheckInput.defaultProps = {
    label: undefined,
    selected: undefined,
};
exports.default = CheckInput;
